import { Checkbox } from "antd";
import styled from "styled-components";
import { COLORS } from "../../layout/theme";

export const CheckboxAntd = styled(Checkbox)`
	.ant-checkbox-inner {
		border: 1px solid ${COLORS.Secondary};
	}
`;
